import Vue, { getCurrentInstance } from 'vue';
import { useNuxtApp } from '~/.nuxt/imports';

/**
 * Resolves a plugin-injected property, preferring the live component instance and
 * falling back to the nuxtApp proxy outside of setup().
 *
 * Mirrors how bridge resolves its own composables (see @nuxt/bridge
 * runtime/composables/router.mjs). The two sources are not interchangeable: the
 * nuxtApp proxy only forwards `$`-prefixed keys and reads them off nuxt2Context,
 * so a component-local value can differ from the context-level one.
 */
export function resolveInjected<K extends keyof Vue>(key: K): Vue[K] {
  const vm = getCurrentInstance()?.proxy;
  return vm ? vm[key] : (useNuxtApp() as any)[key];
}

/** The Nuxt 2 context `app` object, which carries the non-`$` prefixed helpers. */
export function useNuxt2App() {
  return useNuxtApp().nuxt2Context.app;
}
